import React from 'react';
import {Router, Route, Redirect} from 'react-router';
import Home from './Home/Home';
import ProductEPLD from './ProductEPLD/ProductEPLD';
import ProductWMS from './ProductWMS/ProductWMS';
import ProductTMS from './ProductTMS/ProductTMS';
import ProductERP from './ProductERP/ProductERP';
import ProductDC from './ProductDC/ProductDC';
import Service from './Service/Service';
import Solution from './Solution/Solution';
import Case from './Case/Case';
import About from './About/About';

const createRouter = history => {
  return (
    <Router history={history}>
      <Route path='/' component={Home} />
      <Route path='/product/epld' component={ProductEPLD} />
      <Route path='/product/wms' component={ProductWMS} />
      <Route path='/product/tms' component={ProductTMS} />
      <Route path='/product/erp' component={ProductERP} />
      <Route path='/product/dc' component={ProductDC} />
      <Route path='/service/:nav1/:nav2' component={Service}/>
      <Route path='/solution/:path' component={Solution}/>
      <Route path='/case/:nav' component={Case}/>
      <Route path='/about' component={About} />
      <Redirect from='*' to='/' />
    </Router>
  );
};

export default createRouter;



// WEBPACK FOOTER //
// ./src/routes/index.js